const IconWand = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.427 2.427l-.854-.854a.667.667 0 00-.943 0L1.573 12.427a.667.667 0 000 .943l.854.853a.667.667 0 00.943 0L14.427 3.37a.667.667 0 000-.943z"
      stroke="currentColor"
      strokeWidth="1.333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.333 4.667l2 2M3.333 4v2.667M12.667 9.333V12M6.667 1.333v1.334M4.667 5.333H2M14 10.667h-2.667M7.333 2H6"
      stroke="currentColor"
      strokeWidth="1.333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconWand;
